const isWeekendDate = (date: Date) => {
  const weekDay = date.getDay();
  if (weekDay === 0 || weekDay === 6) {
    return true;
  }
  return false;
};

export default isWeekendDate;
